import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonJobTitleList } from "./Common/CommonJobTitleList";

const JobTitlePage = () => {
    return (
        <PageWrapper title='Funções'>
            <Page container='fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <CommonJobTitleList />
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default JobTitlePage;